import { useDispatch } from 'react-redux';

import { requestResetPassword } from '../../../api/login/login.actions';

import PasswordReset from '../../../components/screens/auth/password-reset/PasswordReset';

const PasswordResetContainer = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const reference = urlParams.get('ref');

  const dispatch = useDispatch();

  const resetPassword = (input, resetSuccess) => {
    dispatch(requestResetPassword({ input, onSuccess: () => resetSuccess(true) }));
  };

  const navigateTo = {
    path: '/',
    name: 'Login Screen',
  };

  return <PasswordReset resetPassword={resetPassword} navigateTo={navigateTo} internal={false} reference={reference} />;
};

export default PasswordResetContainer;
